module.exports = __webpack_public_path__ + "img/yt.502bd877.svg";